/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes */
import Component from '@ember/component';
import { computed } from '@ember/object';
import { tagName } from '@ember-decorators/component';

@tagName('')
export default class SchoolDetailsInput extends Component {
  @computed('value', 'savedValue')
  get isDirty() {
    return this.value !== this.savedValue;
  }
}
